import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";

const TutorPage = lazy(() => import("./pages/TutorPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const BattlesPage = lazy(() => import("./pages/BattlesPage"));
const BattleRoomPage = lazy(() => import("./pages/BattleRoomPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));

function PageLoader() {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0d0d1a",
      color: "#c084fc",
      fontFamily: "'Press Start 2P', monospace",
      fontSize: "12px",
    }}>
      Carregando...
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tutor" element={<TutorPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/batalhadebits" element={<BattlesPage />} />
          <Route path="/batalhadebits/:id" element={<BattleRoomPage />} />
          <Route path="/perfil" element={<ProfilePage />} />
          <Route path="/perfil/:id" element={<ProfilePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}
